import {
  BoxIso,
  CalendarMinus,
  CheckCircle,
  Eye,
  LongArrowUpLeft,
  Page,
  XmarkCircle,
} from "iconoir-react";
import { IAppViewSection } from "shared/components";

export enum EventKey {
  All = "ALL",
  Approved = "APPROVED",
  ForReview = "FOR_REVIEW",
  Cancelled = "CANCELLED",
  Declined = "DECLINED",
  Drafts = "DRAFTS",
  Past = "PAST",
}

export const eventViewSections: IAppViewSection[] = [
  {
    items: [
      {
        Icon: BoxIso,
        key: EventKey.All,
        text: "",
        count: 0,
        isSelected: false,
      },
    ],
  },
  {
    items: [
      {
        Icon: CheckCircle,
        key: EventKey.Approved,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: Eye,
        key: EventKey.ForReview,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: CalendarMinus,
        key: EventKey.Cancelled,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: XmarkCircle,
        key: EventKey.Declined,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: Page,
        key: EventKey.Drafts,
        text: "",
        count: 0,
        isSelected: false,
      },
    ],
  },
  {
    items: [
      {
        Icon: LongArrowUpLeft,
        key: EventKey.Past,
        text: "",
        count: 0,
        isSelected: false,
      },
    ],
  },
];
